import api from './api'
import type { AuthResponse, User } from '@/types'

export const authService = {
  async register(email: string, password: string): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/register', {
      email,
      password,
    })
    return response.data
  },

  async login(email: string, password: string): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/login', {
      email,
      password,
    })
    return response.data
  },

  async refreshToken(refreshToken: string): Promise<{ access_token: string; refresh_token: string }> {
    const response = await api.post('/auth/refresh', {
      refresh_token: refreshToken,
    })
    return response.data
  },

  async getProfile(): Promise<User> {
    const response = await api.get<User>('/users/me')
    return response.data
  },

  getGoogleAuthUrl(): string {
    return `${import.meta.env.VITE_API_URL || '/api/v1'}/auth/google`
  },

  async requestPasswordReset(email: string): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/auth/forgot-password', {
      email,
    })
    return response.data
  },

  async verifyResetToken(token: string): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/auth/verify-reset-token', {
      token,
    })
    return response.data
  },

  async resetPassword(token: string, password: string): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>('/auth/reset-password', {
      token,
      password,
    })
    return response.data
  },
}
